import React, { useState, useContext } from 'react';
// import { NavLink } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { DateTime } from "luxon";
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { ReturnValue } from 'use-timer/lib/types';

import UserContext from '../contexts/user';
import EventContext from '../contexts/event';
import Footer from './footer';
import getEncodedImageUrl from '../helpers/get-encoded-image';
import { BackArrow } from './svgs'
import { Presentation } from '../types/presentation';

import { secondsToTime } from '../helpers';

const SidebarQuizUser: React.FC<{
  presentation:Presentation;
  timer: ReturnValue;
  is_survey?: boolean;
}> = ({
  presentation,
  timer,
  is_survey
}) => {
  const userContext = useContext(UserContext);
  const eventContext = useContext(EventContext);

  const location = useLocation();
  const [isVirtual] = useState(queryString.parse(location.search).viewmode === "virtual");
  const intl = useIntl();
  let history = useHistory();

  if (!presentation) {
    return <div />
  }

  return (
    <div className="sidebar-main quiz-user">
      <div className="logo-container">
        {/* <img src="/images/logoplaceholder.png" alt="logo" /> */}
        <span className="day">
          {!isVirtual && <span className="day-text">DAY {presentation.day}</span>}
          <span className="useless-line"></span>
          {!isVirtual && presentation.date && <span className="date">{DateTime.fromFormat(presentation.date, 'yyyy-MM-dd').toFormat('D')}</span>}
        </span>
        <h6>{presentation.name}</h6>
        <div className="speaker-deails-sidebar">
          {
            presentation.speaker_info && presentation.speaker_info.picture ? <img src={getEncodedImageUrl(presentation.speaker_info && presentation.speaker_info.picture, 56, 56)} alt="speaker" /> : <img src="/images/plimgspeaker.png" alt="speaker" />
          }
          <div>
            <p>{presentation.speaker_info && presentation.speaker_info.title} {presentation.speaker_info && presentation.speaker_info.firstName} {presentation.speaker_info && presentation.speaker_info.lastName}</p>
            {
              !isVirtual &&
              presentation.time &&
              presentation.end_time &&
              <span className="time-room-container">
                {secondsToTime(presentation.time)} - {secondsToTime(presentation.end_time)}
                <span className="room-name">{presentation.room_info && presentation.room_info.name}</span>
              </span>
            }
          </div>
        </div>
        <div className="back-link m-t-30">
          <Button onClick={() => history.push(`/${eventContext.slug}${document.location.search}`)} color="link"><BackArrow />{intl.formatMessage({ id: 'button.common.back' })}</Button>
        </div>
      </div>
      <div className="nav-conatiner h-100">
        <div className="quiz-countup-timer">
          {
            !is_survey && timer.status === "RUNNING" && (timer.time > 0.1) ? `${timer.time.toFixed(1)}s` : ""
          }
        </div>
        <div className="ad-container" dangerouslySetInnerHTML={{
          __html: presentation.information ? presentation.information : userContext.currentEvent.ad
        }}></div>
      </div>
      <Footer />
    </div>
  )
}

export default SidebarQuizUser;